"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return RedisMockCacheMgr;
    }
});
const _debug = /*#__PURE__*/ _interop_require_default(require("debug"));
const _ioredismock = /*#__PURE__*/ _interop_require_default(require("ioredis-mock"));
const _CacheMgr = /*#__PURE__*/ _interop_require_default(require("./CacheMgr"));
const _globals = require("~/utils/globals");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const _log = (0, _debug.default)('nc:cache');
let RedisMockCacheMgr = class RedisMockCacheMgr extends _CacheMgr.default {
    constructor(){
        super();
        this.client = new _ioredismock.default();
        // flush the existing db with selected key (Default: 0)
        this.client.flushdb();
        // TODO(cache): fetch orgs once it's implemented
        const orgs = 'noco';
        this.prefix = `${_globals.CACHE_PREFIX}:${orgs}`;
        this.context = 'RedisMockCacheMgr';
    }
};
